import script from "./newsFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./newsFormModal.vue?vue&type=script&setup=true&lang=js"

import "./newsFormModal.vue?vue&type=style&index=0&id=617ba558&lang=scss"

const __exports__ = script;

export default __exports__